export const styles = {
  text: {
    // display: "inline",
    width: "100%",
    fontFamily: "var(--font-family)",
    fontSize: "1.1em",
    paddingBottom: "10px"
  },
  read_or_hide: {
    color: "var(--secondary-color)",
    fontWeight: "bold",
    cursor: "pointer"
  }
};
